import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento', 'transferencia');

const transferenciaActions = {
  gravar: { method: 'POST', url: `${basePath}` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  solicitante: { method: 'GET', url: `${basePath}/solicitante` },
};

export default resource => resource(`${basePath}`, {}, transferenciaActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/transferencia.js